import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { SocialProofPopup } from './components/SocialProofPopup';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ExtraCTAButton } from './components/ExtraCTAButton';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { ContentCarousel } from './components/ContentCarousel';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-[#FDF8F3]" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-0">
      {/* Meta Pixel - invisible tracking */}
      <MetaPixel data-id="element-1" />

      {/* Sticky Countdown Bar */}
      <CountdownBar data-id="element-2" />

      {/* Social Proof Popup - floating */}
      <SocialProofPopup data-id="element-3" />

      {/* Main Content */}
      <main className="pt-14" data-id="element-4">
        <HeroSection data-id="element-5" />
        <PainSection data-id="element-6" />
        <ExtraCTAButton data-id="element-7" />
        <ProblemSection data-id="element-8" />
        <SolutionSection data-id="element-9" />
        <IncludesSection data-id="element-10" />
        <ContentCarousel data-id="element-11" />
        <BeforeAfterSection data-id="element-12" />
        <BonusSection data-id="element-13" />
        <PricingSection data-id="element-14" />
        <GuaranteeSection data-id="element-15" />
        <TestimonialsSection data-id="element-16" />
        <FAQSection data-id="element-17" />
        <FinalCTA data-id="element-18" />
      </main>

      <Footer data-id="element-19" />
    </div>;
}